import { useEffect, useState } from "react";

export default function useGetLimitedTimeDiscountInfo(
  product,
  createdFingerPrint,
  clientVisitTime,
  trigger,
) {
  const [limitedTimeDiscountInfo, setLimitedTimeDiscountInfo] = useState({
    isDiscountValid: undefined,
    remainingTime: 0,
  });

  useEffect(() => {
    // ✅ prevent stale true in early renders
    if (!product || !createdFingerPrint) {
      setLimitedTimeDiscountInfo({ isDiscountValid: false, remainingTime: 0 });
      return;
    }

    const discountDuration =
      product?.timeLimitedDiscount?.discountDuration ||
      product?.indicatorProductLimitedDiscount?.discountDuration;

    if (!discountDuration || discountDuration <= 0) {
      setLimitedTimeDiscountInfo({ isDiscountValid: false, remainingTime: 0 });
      return;
    }

    // ✅ HARD GATE: backend says not eligible
    if (createdFingerPrint?.firstVisitTime === 0) {
      setLimitedTimeDiscountInfo({ isDiscountValid: false, remainingTime: 0 });
      return;
    }

    const parsedStartTime = Number(createdFingerPrint?.firstVisitTime);

    // ✅ fallback chain for visitTime (HomeScreen first renders undefined)
    const sessionVisitTime = Number(sessionStorage.getItem("visitTime"));
    const parsedClientVisitTime = Number(clientVisitTime);

    const fallbackVisitTime = Number.isFinite(parsedClientVisitTime)
      ? parsedClientVisitTime
      : Number.isFinite(sessionVisitTime)
        ? sessionVisitTime
        : Date.now();

    const startTime =
      Number.isFinite(parsedStartTime) && parsedStartTime > 0
        ? parsedStartTime
        : fallbackVisitTime;

    const durationInMilisecond =
      process.env.NODE_ENV === "development"
        ? discountDuration * 6000 * 15
        : discountDuration * 60 * 60 * 1000;

    const remainingTime = startTime + durationInMilisecond - Date.now();

    setLimitedTimeDiscountInfo({
      isDiscountValid: remainingTime > 0,
      remainingTime: remainingTime > 0 ? remainingTime : 0,
    });

    return () => {
      setLimitedTimeDiscountInfo({
        isDiscountValid: undefined,
        remainingTime: 0,
      });
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [product, createdFingerPrint, clientVisitTime, trigger]);

  return limitedTimeDiscountInfo;
}
